import { NgModule } from '@angular/core';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { BackdropComponent } from './components/backdrop/backdrop.component';

@NgModule({
  imports: [SpinnerComponent, BackdropComponent],
  exports: [SpinnerComponent, BackdropComponent],
})
export class SpinnerModule {}
